import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_VIEW_ROLES } from '@/features/medication-register/access'
import { RegisterAttentionPage } from '@/features/medication-register/attention-page'

/** Every open problem across the organisation's registers (read-only view). */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/attention'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_VIEW_ROLES])
    await requireActiveSubscription()
  },
  component: RegisterAttentionPage,
})
